export default __webpack_public_path__ + "static/media/logo.aefe7393.svg";